export const FETCH_SOURCE_AREA = 'FETCH_SOURCE_AREA';
export const FETCH_SOURCE_AREA_SUCCESS = 'FETCH_SOURCE_AREA_SUCCESS';

export const fetchSourceArea = (data) => ({
  type: FETCH_SOURCE_AREA,
  data,
});

export const fetchSourceAreaSuccess = (data) => ({
  type: FETCH_SOURCE_AREA_SUCCESS,
  data,
});



/** WEBPACK FOOTER **
 ** ./src/app/modules/sourceArea/actions.js
 **/